function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
import { BrowserAuthError } from '@azure/msal-browser';

/**
 * This client implements the XMLHttpRequest class to send GET and POST requests.
 */
export class XhrClient {
  /**
   * XhrClient for REST endpoints - Get request
   * @param url
   * @param headers
   * @param body
   */
  sendGetRequestAsync(url, options) {
    var _this = this;

    return _asyncToGenerator(function* () {
      return _this.sendRequestAsync(url, 'GET', _objectSpread(_objectSpread({}, options), {}, {
        headers: _objectSpread(_objectSpread({}, options === null || options === void 0 ? void 0 : options.headers), {}, {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '-1'
        })
      }));
    })();
  }
  /**
   * XhrClient for REST endpoints - Post request
   * @param url
   * @param headers
   * @param body
   */


  sendPostRequestAsync(url, options) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      return _this2.sendRequestAsync(url, 'POST', options);
    })();
  }
  /**
   * Helper for XhrClient requests.
   * @param url
   * @param method
   * @param options
   */


  sendRequestAsync(url, method, options) {
    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      xhr.open(method, url,
      /* async: */
      true);
      this.setXhrHeaders(xhr, options);

      xhr.onload = () => {
        if (xhr.status < 200 || xhr.status >= 300) {
          reject(xhr.responseText);
        }

        try {
          var jsonResponse = JSON.parse(xhr.responseText);
          var networkResponse = {
            headers: this.getHeaderDict(xhr),
            body: jsonResponse,
            status: xhr.status
          };
          resolve(networkResponse);
        } catch (e) {
          reject(xhr.responseText);
        }
      };

      xhr.onerror = () => {
        reject(xhr.status);
      };

      if (method === 'POST' && options && options.body) {
        xhr.send(options.body);
      } else if (method === 'GET') {
        xhr.send();
      } else {
        throw BrowserAuthError.createHttpMethodNotImplementedError(method);
      }
    });
  }
  /**
   * Helper to set XHR headers for request.
   * @param xhr
   * @param options
   */


  setXhrHeaders(xhr, options) {
    if (options && options.headers) {
      var headers = options.headers;
      Object.keys(headers).forEach(key => {
        xhr.setRequestHeader(key, headers[key]);
      });
    }
  }
  /**
   * Gets a string map of the headers received in the response.
   *
   * Algorithm comes from https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/getAllResponseHeaders
   * @param xhr
   */


  getHeaderDict(xhr) {
    var headerString = xhr.getAllResponseHeaders();
    var headerArr = headerString.trim().split(/[\r\n]+/);
    var headerDict = {};
    headerArr.forEach(value => {
      var parts = value.split(': ');
      var headerName = parts.shift();
      var headerVal = parts.join(': ');

      if (headerName && headerVal) {
        headerDict[headerName] = headerVal;
      }
    });
    return headerDict;
  }

}